module.exports = __webpack_public_path__ + "img/measurement_outer.3c55cfe7.svg";